var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addr-pdf" }, [
    _c("div", { staticClass: "addr-pdf__article" }, [
      _c(
        "div",
        { staticClass: "header-holder" },
        [
          _c("corpIcon", { staticStyle: { "max-height": "52px" } }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "addr-pdf__article__text",
              staticStyle: { display: "inline-block", width: "80%" },
            },
            [
              _vm._v(
                "\n                Отчет по результатам онлайн-проверки адреса на " +
                  _vm._s(_vm.currentDate) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main-info" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "addr-pdf__source" }, [
        _c("h3", [_vm._v("Адрес: ")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.address))]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "result" }, [
      _vm._m(1),
      _vm._v(" "),
      _vm.isFL
        ? _c("div", { staticClass: "fl" }, [
            _c("h3", [_vm._v("Физические лица:")]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.data.fl, function (fl, i) {
                return _c("li", { key: i }, [
                  _c("span", [_vm._v(_vm._s(i + 1) + ".")]),
                  _vm._v(_vm._s(fl) + "\n                "),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isIP
        ? _c("div", { staticClass: "ip" }, [
            _c("h3", [_vm._v("Индивидуальные предприниматели:")]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.data.ip, function (ip, i) {
                return _c(
                  "li",
                  { key: i },
                  [
                    _c("span", [_vm._v(_vm._s(i + 1) + ".")]),
                    _vm._v(" "),
                    ip.ogrn
                      ? _c(
                          "a",
                          {
                            staticClass: "tooltip-link",
                            attrs: {
                              href:
                                _vm.window.location.origin +
                                "/company/" +
                                ip.ogrn,
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(ip.name))]
                        )
                      : _c("span", [_vm._v(_vm._s(ip.name))]),
                    _vm._v(" "),
                    ip.ogrn
                      ? _c("tooltip", {
                          staticClass: "no_print",
                          attrs: { ogrn: ip.ogrn },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isUL
        ? _c("div", { staticClass: "ul" }, [
            _c("h3", [_vm._v("Юридические лица:")]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.data.ul, function (ul, i) {
                return _c(
                  "li",
                  { key: i },
                  [
                    _c("span", [_vm._v(_vm._s(i + 1) + ".")]),
                    _vm._v(" "),
                    ul.ogrn
                      ? _c(
                          "a",
                          {
                            staticClass: "tooltip-link",
                            attrs: {
                              href: "/company/" + ul.ogrn,
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(ul.name))]
                        )
                      : _c("span", [_vm._v(_vm._s(ul.name))]),
                    _vm._v(" "),
                    ul.ogrn
                      ? _c("tooltip", {
                          staticClass: "no_print",
                          attrs: { ogrn: ul.ogrn },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "addr-pdf__header" }, [
      _c("div", [_vm._v("ИСХОДНЫЕ ДАННЫЕ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "addr-pdf__header" }, [
      _c("div", [_vm._v("РЕЗУЛЬТАТ ПОИСКА")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }